import { FC, useEffect, useState } from 'react';
import * as React from 'react';

import { clsx } from 'clsx';
import styled from 'styled-components';

import { Container } from '@crehana/ui';

import { ScrollTopFAB } from './components';
import useDashboardContext from './context/useDashboardContext';

const ScrollTop = styled(ScrollTopFAB)`
  bottom: 80px;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    bottom: 40px;
  }
`;

const ContainerStyled = styled(Container)`
  margin-top: 152px;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    margin-top: 112px;
  }
`;

export interface RouteWrapperProps {
  className?: string;
  scrollTopHidden?: boolean;
}

const RouteWrapper: FC<React.PropsWithChildren<RouteWrapperProps>> = ({
  className = '',
  scrollTopHidden,
  children,
}) => {
  const { sectionRef, scrollTop } = useDashboardContext();
  const [isScrolled, setIsScrolled] = useState<boolean>(false);

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(!!sectionRef.current?.scrollTop);
    };

    if (!scrollTopHidden && sectionRef.current) {
      sectionRef.current.addEventListener('scroll', onScroll);
    }
    return () => {
      if (!scrollTopHidden && sectionRef.current) {
        sectionRef.current.removeEventListener('scroll', onScroll);
      }
    };
  }, []);

  return (
    <div
      ref={sectionRef}
      className={clsx(
        'w-full h-screen flex flex-col justify-between overflow-auto',
        className,
      )}
    >
      <div>{children}</div>
      {!scrollTopHidden && (
        <ContainerStyled
          type="dashboard"
          className={`sticky bottom-0 left-0 right-0 w-full flex justify-end h-0 overflow-visible z-7 ${
            isScrolled ? 'cui-is-visible' : 'cui-is-hidden'
          }`}
        >
          <div className="relative w-full h-full overflow-visible">
            <ScrollTop className="absolute right-0" onScrollTop={scrollTop} />
          </div>
        </ContainerStyled>
      )}
    </div>
  );
};

export default RouteWrapper;
